import { LoadingAnimation } from '@outbound-ai/ursa'
import { MaintenanceNotification } from 'features/claims/types'
import { useRef, useState } from 'react'
import { GrHostMaintenance } from 'react-icons/gr'
import { Button, ObModal } from '@outbound-ai/ursa'
import styled from 'styled-components'
import DOMPurify from 'dompurify'

interface IProps {
  showModal: boolean
  setNotificationClose: (value: boolean) => void
  notificationData: MaintenanceNotification[]
}

const TITLE_NOTIFICATION = 'System Notification'

export const MaintenanceNotificationModel = ({ showModal, setNotificationClose, notificationData }: IProps) => {
  const notificationCount = notificationData.length
  const [show, setShowModal] = useState(showModal)
  const [isTransitioning, setIsTransitioning] = useState(false)
  const transitionTimeout = useRef<ReturnType<typeof setTimeout> | null>(null)

  const [currentIndex, setCurrentIndex] = useState(0)
  const currentNotification = notificationData[currentIndex]
  const buttonText = currentIndex < notificationCount - 1 ? 'Next' : 'Okay!'

  const handleNotification = () => {
    if (isTransitioning) return
    setIsTransitioning(true)

    transitionTimeout.current = setTimeout(() => {
      transitionTimeout.current = null

      if (currentIndex < notificationCount - 1) {
        setCurrentIndex((prev) => prev + 1)
        setIsTransitioning(false)
      } else {
        setShowModal(false)
        setIsTransitioning(false)
        setNotificationClose(false)
      }
    }, 1000)
  }

  return (
    <ObModal show={show} customSize="medium" size="lg" height="auto" hideCloseButton={true}>
      <Div>
        {isTransitioning ? (
          <LoadingAnimationWrapper>
            <LoadingAnimation /> Loading...
          </LoadingAnimationWrapper>
        ) : (
          <>
            <h2>{currentNotification?.title || TITLE_NOTIFICATION}</h2>
            <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(currentNotification?.message || '') }} />
            <div className="maintenance-container">
              <GrHostMaintenance className="maintenance-icon"></GrHostMaintenance>
            </div>
            <div className="d-flex justify-content-center ">
              <Button
                className="lets-go-btn"
                variant="primary"
                size="large"
                radius="rounded"
                onClick={handleNotification}
              >
                {buttonText}
              </Button>
            </div>
          </>
        )}
      </Div>
    </ObModal>
  )
}

const Div = styled.div`
  text-align: center;
  margin: 0 auto;
  h2 {
    ${({ theme }) => theme.typography.h3.bold};
    margin-bottom: 0.5rem;
    color: ${({ theme }) => theme.colors.primary.neutral};
  }
  p {
    ${({ theme }) => theme.typography.m.normal};
    color: ${({ theme }) => theme.colors.grey.dark};
  }
  .maintenance-container {
    margin-top: 2rem;
    display: flex;
    justify-content: space-evenly;
    .maintenance-icon {
      font-size: 3.875rem;
      color: ${({ theme }) => theme.colors.primary.darker};
    }
    p {
      margin-top: 1rem;
      width: 7.25rem;
      font-size: 0.875rem;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.14;
      letter-spacing: normal;
      text-align: center;
      color: ${({ theme }) => theme.colors.neutral.neutral};
    }
  }

  .lets-go-btn {
    width: 11.125rem;
    margin-top: 2rem;
    margin-bottom: 3rem;
  }
`

const LoadingAnimationWrapper = styled.div`
  width: 100%;
  height: 23.4375rem;
  display: flex;
  justify-content: center;
  align-items: center;
`
